// Zentrale Konfiguration – Kontaktdaten hier eintragen, sobald verfügbar.
export const CONTACT = {
  email: "kontakt@webdesign-damerow.de", // Kontakt-E-Mail
  phone: "", // z. B. "+49 30 1234567" – aktuell bewusst leer gelassen
};

export const LOGO_URL =
  "/images/logo-header.webp";

export const FOOTER_LOGO_URL =
  "/images/logo-footer.png";

export const IMAGES = {
  heroMockup:
    "/images/hero-workspace.jpg",
  exampleProject:
    "/images/salon-example.jpg",
};

export const NAV_ITEMS = [
  { label: "Start", href: "/" },
  { label: "Webdesign Berlin", href: "/webdesign-berlin" },
  { label: "Für Unternehmen", href: "/webdesign-fuer-unternehmen" },
  { label: "Landingpage", href: "/landingpage-erstellen-lassen" },
  { label: "Relaunch", href: "/website-relaunch" },
  { label: "Kontakt", href: "/kontakt" },
];

export const BENEFITS = [
  {
    title: "Professioneller erster Eindruck",
    text: "Ein moderner Auftritt schafft sofort Vertrauen bei neuen Kunden.",
    icon: "Sparkles",
  },
  {
    title: "Mobil optimiert",
    text: "Ihre Website funktioniert einwandfrei auf Handy, Tablet und Desktop.",
    icon: "Smartphone",
  },
  {
    title: "Klare Kontaktmöglichkeiten",
    text: "Anruf, E-Mail und Standort sind für Besucher sofort erreichbar.",
    icon: "PhoneCall",
  },
  {
    title: "Bessere Übersicht für Kunden",
    text: "Leistungen, Öffnungszeiten und Infos auf einen Blick.",
    icon: "LayoutGrid",
  },
  {
    title: "Vertrauen durch moderne Gestaltung",
    text: "Ein aufgeräumtes Design wirkt seriös und hochwertig.",
    icon: "ShieldCheck",
  },
  {
    title: "Für kleine Unternehmen",
    text: "Persönliche digitale Lösungen aus Berlin – deutschlandweit umsetzbar.",
    icon: "MapPin",
  },
];

export const AUDIENCE = [
  { title: "Friseursalons", icon: "Scissors" },
  { title: "Kosmetikstudios", icon: "Flower2" },
  { title: "Handwerksbetriebe", icon: "Hammer" },
  { title: "Reinigungsfirmen", icon: "SprayCan" },
  { title: "Lokale Dienstleister", icon: "Store" },
  { title: "Unternehmen ohne Website", icon: "Globe" },
];

export const SERVICES = [
  {
    id: "websites",
    title: "Webdesign für kleine Unternehmen",
    icon: "Monitor",
    description:
      "Sie möchten eine Website erstellen lassen oder Ihren bestehenden Auftritt überarbeiten? Ich gestalte Onepager, Unternehmenswebsites und Landingpages, die Ihre Leistungen verständlich zeigen und Interessenten einen klaren Weg zur Anfrage bieten – auf Smartphone und Desktop.",
    examples: [
      "Unternehmenswebsites und Onepager",
      "Landingpages für konkrete Angebote",
      "Relaunch und Website-Fertigstellung",
      "Klare Leistungsdarstellung und Kontaktwege",
    ],
  },
  {
    id: "buchungssysteme",
    title: "Online-Buchungssysteme",
    icon: "CalendarDays",
    description:
      "Eine passende Online-Terminbuchung ermöglicht Ihren Kunden, Leistungen und verfügbare Zeiten selbst auszuwählen. Ich richte eine geeignete Buchungslösung ein und binde sie nach technischer Prüfung in Ihre Website ein. Welche Termine direkt buchbar sind, richtet sich nach Ihrem tatsächlichen Ablauf.",
    examples: [
      "Online-Terminbuchung",
      "Einbindung in bestehende Websites",
      "Übersichtliche Terminverwaltung",
      "Automatische Buchungsbestätigungen",
    ],
  },
  {
    id: "automatisierungen-ki",
    title: "Automatisierungen & KI",
    icon: "Workflow",
    description:
      "Wiederkehrende Aufgaben müssen nicht jedes Mal von Hand erledigt werden. Ich verbinde klar abgegrenzte Schritte, etwa das Erfassen einer Anfrage, die Übertragung in eine Kundenübersicht und eine interne Benachrichtigung. KI kann ergänzend Zusammenfassungen oder Antwortentwürfe vorbereiten.",
    examples: [
      "Kundenanfragen geordnet erfassen",
      "Informationen in eine Kundenübersicht übertragen",
      "Interne Erinnerungen und Angebotsvorbereitung",
      "KI-gestützte Zusammenfassungen und Antwortentwürfe",
    ],
    note:
      "Wichtige Entscheidungen und Freigaben bleiben bei Ihnen.",
  },
];

export const PACKAGES = [
  {
    id: "website-starter",
    title: "Website Starter",
    description:
      "Ein professioneller Einstieg für Selbstständige und kleine Unternehmen.",
    price: "ab 790 €",
    priceNote: "einmalig",
    features: [
      "Individuell gestalteter Onepager",
      "Darstellung von Leistungen und Unternehmen",
      "Smartphone- und Desktop-Optimierung",
      "Kontaktformular",
      "Grundlegende SEO-Einrichtung",
    ],
    cta: "Website anfragen",
  },
  {
    id: "business-website",
    title: "Business Website",
    description:
      "Mehr Platz für Ihre Leistungen und einen überzeugenden Unternehmensauftritt.",
    price: "ab 1.290 €",
    priceNote: "einmalig",
    features: [
      "Bis zu fünf Inhaltsseiten",
      "Individuelle Gestaltung",
      "Klare Nutzerführung und Kontaktmöglichkeiten",
      "Smartphone- und Desktop-Optimierung",
      "Kontaktformular",
      "Grundlegende SEO-Einrichtung",
    ],
    cta: "Business-Website anfragen",
  },
  {
    id: "online-buchungssystem",
    title: "Online-Buchungssystem",
    description:
      "Termine online buchen – mit weniger Abstimmung per Telefon oder Nachricht.",
    price: "ab 990 €",
    priceNote: "einmalig",
    features: [
      "Einrichtung einer passenden Buchungslösung",
      "Einbindung in die bestehende Website",
      "Auswahl von Leistung und verfügbarem Termin",
      "Übersichtliche Verwaltung der Buchungen",
      "Automatische Buchungsbestätigung per E-Mail",
    ],
    note:
      "Der Einstiegspreis gilt für einen einfachen Buchungsablauf. Mehrere Mitarbeitende, Räume oder besondere Buchungsregeln werden individuell kalkuliert.",
    cta: "Buchungssystem anfragen",
  },
  {
    id: "automatisierungen-ki",
    title: "Automatisierungen & KI",
    description:
      "Weniger wiederkehrende Handarbeit bei Ihren Kundenanfragen und internen Abläufen.",
    price: "ab 490 €",
    priceNote: "einmalig",
    scope:
      "Automatisierung eines einzelnen, klar abgegrenzten Ablaufs – beispielsweise eine Formularanfrage automatisch in Ihre Kundenübersicht übertragen und intern zur Bearbeitung weiterleiten.",
    note:
      "KI kann zusätzlich eingesetzt werden, etwa für Zusammenfassungen oder Antwortentwürfe. Ob sie sinnvoll ist, klären wir anhand Ihres tatsächlichen Ablaufs.",
    cta: "Automatisierung anfragen",
  },
  {
    id: "individuelle-loesung",
    title: "Individuelle Lösung",
    description: "Ihr Vorhaben passt nicht in ein fertiges Paket?",
    price: "Preis nach Umfang",
    details:
      "Ob Website mit Buchungssystem, mehrere miteinander verbundene Abläufe oder eine Erweiterung bestehender Systeme: Wir klären gemeinsam Anforderungen und technische Möglichkeiten. Anschließend erhalten Sie ein individuelles Angebot mit klar beschriebenem Leistungsumfang.",
    cta: "Projekt besprechen",
    wide: true,
  },
];

const packagePrice = (id) => PACKAGES.find((item) => item.id === id)?.price;

export const FAQ_ITEMS = [
  {
    question: "Welche Lösung passt zu meinem Unternehmen?",
    answer:
      "Das hängt davon ab, was Sie verbessern möchten. Eine Website kann Ihre Leistungen verständlicher präsentieren, ein Buchungssystem die Terminvergabe vereinfachen und eine Automatisierung wiederkehrende Arbeitsschritte verbinden. Im Erstgespräch klären wir den Bedarf und grenzen einen passenden Umfang ab.",
  },
  {
    question: "Was kostet eine Website oder ein digitales System?",
    answer: `Ein Onepager startet ${packagePrice("website-starter")}, eine Business-Website mit bis zu fünf Inhaltsseiten ${packagePrice("business-website")}. Ein einfaches Online-Buchungssystem beginnt ${packagePrice("online-buchungssystem")}, eine einzelne klar abgegrenzte Automatisierung ${packagePrice("automatisierungen-ki")}. Den verbindlichen Preis erhalten Sie nach Klärung des Leistungsumfangs.`,
  },
  {
    question: "Kann ein Buchungssystem in meine bestehende Website eingebunden werden?",
    answer:
      "Das hängt vom verwendeten Website-System, den Zugängen und Ihren Anforderungen ab. Vor einem Angebot prüfe ich, wie sich eine passende Buchungslösung einbinden lässt und welche Leistungen, Mitarbeitenden oder Räume berücksichtigt werden müssen.",
  },
  {
    question: "Entstehen zusätzlich laufende Kosten?",
    answer:
      "Je nach Lösung können laufende Kosten für Domain, Hosting, Buchungssoftware, Schnittstellen oder KI-Nutzung entstehen. Diese werden vor Beauftragung offengelegt. Laufende Betreuung wird separat vereinbart.",
  },
  {
    question: "Muss bei einer Automatisierung immer KI eingesetzt werden?",
    answer:
      "Nein. Viele Aufgaben lassen sich mit festen Regeln automatisieren. KI kann ergänzend sinnvoll sein, wenn unterschiedliche Texte zusammengefasst oder Entwürfe vorbereitet werden sollen. Ob sie einen Vorteil bietet, prüfen wir am konkreten Ablauf.",
  },
  {
    question: "Ist eine Zusammenarbeit außerhalb von Berlin möglich?",
    answer:
      "Ja. Ich arbeite mit Unternehmen in ganz Deutschland zusammen. Anforderungen, Abstimmung und Übergabe können online besprochen werden.",
  },
];

export const STEPS = [
  {
    n: "01",
    title: "Vorhaben schildern",
    text: "Sie beschreiben kurz, was Sie verbessern möchten.",
    icon: "Mail",
  },
  {
    n: "02",
    title: "Anforderungen klären",
    text: "Wir klären Ziele, vorhandene Systeme und den sinnvollen Umfang.",
    icon: "MessageSquare",
  },
  {
    n: "03",
    title: "Angebot erhalten",
    text: "Vor der Umsetzung erhalten Sie ein Angebot mit klar beschriebenem Leistungsumfang und transparenten Kosten.",
    icon: "FileText",
  },
  {
    n: "04",
    title: "Umsetzung",
    text: "Ich setze den vereinbarten Leistungsumfang um und halte Sie auf dem Laufenden.",
    icon: "Code2",
  },
  {
    n: "05",
    title: "Prüfung & Freigabe",
    text: "Sie prüfen die Umsetzung und geben vereinbarte Anpassungen gesammelt zurück.",
    icon: "CheckCircle2",
  },
  {
    n: "06",
    title: "Übergabe",
    text: "Nach Ihrer Freigabe wird die vereinbarte Lösung übergeben oder veröffentlicht.",
    icon: "Rocket",
  },
];
